angular.module('unergie.main')
.directive('salesTunnelClosingPartnerV3', ($q, $state, ApiUser, MetaWatcher, DraftsBasic, ErrorCatcher, AlertManager, AuthService, AdminComments) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        draftServices: '=',
        validated: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelClosingPartnerV3.html',
    link($scope) {
        $scope.closingPartnerCollapsed = !!$scope.draft.draftElec.id_prm
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.minDate = moment().toDate()
        $scope.maxDate = moment().add(30, 'day').toDate()
        $scope.contactDate = moment().add(1, 'day').toDate()
        $scope.contactSlot = 'WHENEVER'

        $scope.$watch('draft', (draft) => {
            $scope.closingPartnerCollapsed = !!$scope.draft.draftElec.id_prm
        })

        $scope.slots = [
            { id: 'MORNING', label: 'Le matin à partir de 9h' },
            { id: 'NOON', label: 'Entre midi et 14h' },
            { id: 'AFTERNOON', label: `L'après-midi, avant 17h30` },
            { id: 'EVENING', label: `En fin de journée` },
            { id: 'WHENEVER', label: `Indifférent` },
        ]

        $scope.canShoot = () => {
            const VALIDATOR_NAMES = [
                'isCivDefined',
                'isGivennameDefined',
                'isSnDefined',
                'isSecondNameWellDefined',
                'isMailDefined',
                'isPhoneDefined',
            ]
            return _.every(_.map(_.pick($scope.validated, VALIDATOR_NAMES), (val) => { return _.isObject(val) ? val.value : val }))
        }

        $scope.transferToSeniorAdvisor = () => {
            $scope.transferingToSeniorAdvisor = true
            const payload = { contactDate: moment($scope.contactDate).format('YYYY-MM-DD'), contactSlot: $scope.contactSlot }
            return $scope.saveDraft({ comments: $scope.draft.comments }, true)
            .then(() => {
                return $scope.draftServices.linkDraftToUser().then(() => {
                    return DraftsBasic.getDraftById({ id_draft_basic: $scope.draft.id }).$promise.then((draft) => {
                        AdminComments.addComment({ object: draft.draftElec.id, comment: $scope.draft.comments }).$promise.catch(ErrorCatcher)
                        return ApiUser.transferToSeniorAdvisor({ id_draft_basic: $scope.draft.id }, payload).$promise.then((result) => {
                            AlertManager.success(`E-mail envoyé, et ébauche transférée à un conseiller Plüm.`, 6000)
                        })
                    })
                })
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.transferingToSeniorAdvisor = false
            })
        }
    },
}))
